export const STUDENT = '/students'
export const STUDENT_INFO = `${STUDENT}/info`
export const STUDENT_INFO_PUBLIC = '/:category/student-info'
